<script setup lang="ts">
import DescriptionList from "../DescriptionList/DescriptionList.component.vue";
import DescriptionListEntry from "../DescriptionList/DescriptionListEntry.component.vue";
import DescriptionListKey from "../DescriptionList/DescriptionListKey.component.vue";
import DescriptionListValue from "../DescriptionList/DescriptionListValue.component.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <DescriptionList>
    <DescriptionListEntry>
      <template #key>
        <DescriptionListKey :vertical="true">
          <div class="info-tag--key">
            {{ title }}
          </div>
        </DescriptionListKey>
      </template>

      <template #values>
        <DescriptionListValue :vertical="true">
          <div class="info-tag--value">
            {{ value }}
          </div>
        </DescriptionListValue>
      </template>
    </DescriptionListEntry>
  </DescriptionList>
</template>

<style>
.info-tag--key {
  @apply text-16/24;

  margin-block-end: 10px;
}

.info-tag--value {
  @apply text-36/36;

  font-weight: 700;
}
</style>
